exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".warningBar[data-v-01caab60]{display:flex;align-items:center;min-height:50px;font-family:Roboto,sans-serif}.warningIcon[data-v-01caab60]{height:100%;width:50px;display:flex;align-items:center;justify-content:center}.warningIcon i[data-v-01caab60]{color:#c62d2d}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-01caab60","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/assets/Dynamic/ModularComponents/waningbar.vue
// module id = 571
// module chunks = 0